var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"hot-text-highlight"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.toFibText(_vm.content.resource.text))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }